import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppStore = defineStore('banc', () => ({
    theme: ref('light'),
    users: ref([]),
    upload: ref(),
    exclude: ref([]),
    visibleProof: ref(true),
    uploaded: ref({}),
    shared: ref({}),
    banc: ref(BigInt(0)),
    faq: ref({}),
    signature: ref(),
    encryptionUserName: ref(),
    encryptionUserDisplayName: ref(),
    swiperMode: ref('users'),
    web3TransactionHashes: ref([]),
    camera: ref('selfie'),
    allGrids: ref([]),
    collisions: ref([]),
    activeDeposit: ref(),
    dashPlayers: ref({}),
    stats: ref({}),
    aname: ref({})
}),
    {

        persist: {
            debug: false,
        }
    }
)